import { DescriptorDeUsuario } from 'src/descriptor';

export function puedePoseerMatriculas(usuario: DescriptorDeUsuario) {
    // Un administrador siempre "es" asesor (es todo), pero no tiene sentido
    // que se muestren "sus matrículas", así que se excluye administrador
    // explícitamente. Este siempre puede ver todas las matrículas en supervisión.
    return (
        usuario.tieneAlgunaDeEstasFunciones('asesor') &&
        !usuario.funciones.includes('administrador')
    );
}



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/puedePoseerMatriculas.ts